export const LOADING = {
  CONTAINER: 'loading-container',
  INDICATOR: 'loading-indicator',
  MESSAGE: 'loading-message'
} as const;
